<div class="sidebar {{ sidebarStyle }}" *ngIf="isLoggedIn">
  <div class="sidebar-wrapper">
    <ul class="navbar-nav">
      <li class="nav-item">
        <div class="logo-container">
          <img src="assets/logo.svg" alt="Logo" class="logo-icon" />
        </div>
        <a class="nav-link" (click)="toggleSidebar()">
          <div class="sidebar-element sidebar-logo">
            <h4>Parcări Oradea<br /><span>Admin area</span></h4>
            <div class="nav-icon-container">
              <img *ngIf="!sidebarCollapsed" src="assets/toggle-btn-left.svg" alt="Menu" class="nav-icon" />
              <img *ngIf="sidebarCollapsed" src="assets/toggle-btn-right.svg" alt="Menu" class="nav-icon" />
            </div>
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/users" [class.active-link]="router.url == '/users'">
          <div class="sidebar-element sidebar-users {{
              router.url == '/users' ? 'sidebar-element-active' : ''
            }}">
            <i class="bi bi-people"></i>
            <p>Utilizatori</p>
          </div>
        </a>
      </li>
      <!-- <li class="nav-item">
        <a class="nav-link" routerLink="/parking-agents" [class.active-link]="router.url == '/parking-agents'">
          <div
            class="sidebar-element sidebar-parking-agents {{ router.url == '/parking-agents' ? 'sidebar-element-active' : '' }}">
            <i class="bi bi-person-badge"></i>
            <p>Agenți de parcare</p>
          </div>
        </a>
      </li> -->
      <!-- <li class="nav-item">
        <a class="nav-link" routerLink="/riparian-requests" [class.active-link]="router.url == '/riparian-requests'">
          <div class="sidebar-element sidebar-riparian-requests {{
              router.url == '/riparian-requests' ? 'sidebar-element-active' : ''
            }}">
            <i class="bi bi-building"></i>
            <p>Cerere de parcare riverani</p>
            <span class="badge rounded-pill d-inline-flex align-items-center ms-auto">{{
              riparianParkingSubscriptionCount }}</span>
          </div>
        </a>
      </li> -->
      <!-- <li class="nav-item">
        <a class="nav-link" routerLink="/home-parking-requests"
          [class.active-link]="router.url == '/home-parking-requests'">
          <div class="sidebar-element sidebar-home-parking-requests {{
              router.url == '/home-parking-requests'
                ? 'sidebar-element-active'
                : ''
            }}">
            <i class="bi bi-house-door"></i>
            <p>Cerere de parcare la domiciliu</p>
            <span class="badge rounded-pill d-inline-flex align-items-center ms-auto">{{
              homeParkingSubscriptionParkingCount }}</span>
          </div>
        </a>
      </li> -->
      <li class="nav-item">
        <a class="nav-link" routerLink="/tickets" [class.active-link]="router.url == '/tickets'">
          <div class="sidebar-element sidebar-tickets {{
              router.url == '/tickets' ? 'sidebar-element-active' : ''
            }}">
            <i class="bi bi-file-text"></i>
            <p>Tichete</p>
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/subscriptions" [class.active-link]="router.url == '/subscriptions'">
          <div
            class="sidebar-element sidebar-subscriptions {{ router.url == '/subscriptions' ? 'sidebar-element-active' : '' }}">
            <i class="bi bi-card-list"></i>
            <p>Abonamente</p>
          </div>
        </a>
      </li>
      <li class="nav-item">
        <div class="sidebar-element sidebar-logout">
          <i class="bi bi-box-arrow-left"></i>
          <p>
            <button class="logout-btn" (click)="logout()" routerLink="/login">
              Logout
            </button>
          </p>
        </div>
      </li>
    </ul>
  </div>
</div>